/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Approve_Dialog_ConfirmInputs */

const vi_stocktake_approve_dialog_confirm = /** @type {(inputs: Stocktake_Approve_Dialog_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duyệt + tạo phiếu điều chỉnh`)
};

/**

* @param {Stocktake_Approve_Dialog_ConfirmInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_approve_dialog_confirm = /** @type {((inputs?: Stocktake_Approve_Dialog_ConfirmInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Approve_Dialog_ConfirmInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_approve_dialog_confirm(inputs)
});